var myHistory = [];

export const pageLoad = (urlChangeType) => {
  window.history.pushState(myHistory, urlChangeType, `/${urlChangeType}`);
};

export const nav_to_details = () => {
  myHistory.push("page_im_on_now");
  window.history.replaceState(myHistory, "name", "/");
};
